import { classicoTheme } from "./classico";
import { preenchidoTheme } from "./preenchido";

const MARKER_THEMES = {
  classico: classicoTheme,
  preenchido: preenchidoTheme,
};

export const DEFAULT_MARKER_THEME = "classico";

export const getMarkerTheme = (tema) =>
  MARKER_THEMES[tema] ?? MARKER_THEMES[DEFAULT_MARKER_THEME];
